module.exports = __webpack_public_path__ + "632add3ac6c16065a22f4cea0d4dd46c.svg";